<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>圈子列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <el-row class="form-row">
        <el-text style="width:100px; text-align: right;">类型：</el-text>
        <el-col :span="4">
          <el-radio v-model="subData.type" label="游戏">游戏</el-radio>
          <el-radio v-model="subData.type" label="情感">情感</el-radio>
        </el-col>
      </el-row>
      <el-row class="form-row">
        <el-text style="width:100px; text-align: right;">圈子：</el-text>
        <el-col :span="4">
          <el-input placeholder="请输入圈子" style="width:400px;" maxlength="10" v-model="subData.name"></el-input>
        </el-col>
      </el-row>
      <el-row class="form-row" v-if="false">
        <el-text style="width:100px; text-align: right;">图标：</el-text>
        <el-col :span="4">
          <el-input placeholder="请输入图标" style="width:400px;" v-model="subData.icon"></el-input>
        </el-col>
      </el-row>

      <el-row class="bt" style="padding:15px 0; padding-left: 100px;">
        <el-button type="primary" @click="submitEvent">确定</el-button>
        <el-button plain type="primary" @click="backEvent">返回</el-button>
      </el-row>
    </el-card>
  </div>
</template>

  
<script>

export default {
  data() {
    return {
      id: this.$route.query.id?this.$route.query.id:0,
      subData:{
        type:'',
        name : '',
        icon : '',

      }
    }
  },
  mounted:function(){
    if(this.id>0){
      this.getData()
    }
  },
  methods: {
    backEvent(){
        this.$router.go(-1)
    },
    getData(){
      var ths = this
      ths.$get('/Categorys/queryById?id='+ths.id)
      .then(function (res) { 
          if(res.success){
            ths.subData = res.data
          }
      })
      .catch(function (err) {
        console.log(err)
      })    
    },
    submitEvent() {
      const ths = this;

      ths.$post('/Categorys/edit?', ths.subData)
        .then(function (res) { 
            alert(res.msg)
            if(res.success){
              ths.$router.push("/Admin/CategorysList")
            }
        })
        .catch(function (err) {
          console.log(err)
        })      
      },
   }
}

</script>

<style>
.form-row{
  padding:15px 0; 
}
</style>